module.exports = function() {
    var memory = {};

    return {
        copy: copy,
        paste: paste
    };

    function copy(source) {
        memory = _.cloneDeep(source);

        if (source.type === 'default') {
            memory.type = 'custom';
        }
    }

    function paste(destination) {
        destination.type = memory.type;
        destination.available = memory.available;
        destination.times = _.get(memory, 'times');

        if (memory.absence) {
            destination.absence = memory.absence;

            if (memory.reason) {
                destination.reason = memory.reason;
            } else {
                destination.reason = 'other';
            }
        }
    }
};